import script from "./AuthLogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthLogin.vue?vue&type=script&lang=ts&setup=true"

import "./AuthLogin.vue?vue&type=style&index=0&id=3f85f007&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f85f007"]])

export default __exports__